const setDocumentAddress= (val = null) => {
  return {
    type: 'SET_DOCUMENTADDRESS',
    data: val,
  }
}
const setDocumentNumber = (val = null) => {
  return {
    type: 'SET_DOCUMENTNUMBER',
    data: val,
  }
}

const setDocumentVillageName = (val = null) => {
  return {
    type: 'SET_DOCUMENTVILLAGENAME',
    data: val,
  }
}

const setDocumentVillage = (val = null) => {
  return {
    type: 'SET_DOCUMENTVILLAGE',
    data: val,
  }
}

const setDocumentFloor = (val = null) => {
  return {
    type: 'SET_DOCUMENTFLOOR',
    data: val,
  }
}

const setDocumentRoad = (val = null) => {
  return {
    type: 'SET_DOCUMENTROAD',
    data: val,
  }
}

const setDocumentProvince = (id = null, val = null) => {
  return {
    type: 'SET_DOCUMENTROVINCE',
    id,
    data: val,
  }
}

const setDocumentDistrict = (id = null, val = null) => {
  return {
    type: 'SET_DOCUMENTDISTRICT',
    id,
    data: val,
  }
}

const setDocumentSubDistrict = (id = null, val = null) => {
  return {
    type: 'SET_DOCUMENTSUBDISTRICT',
    id,
    data: val,
  }
}

const setDocumentZipcode = (val = null) => {
  return {
    type: 'SET_DOCUMENTZIPCODE',
    data: val,
  }
}

export default {
  setDocumentAddress,
  setDocumentNumber,
  setDocumentVillageName,
  setDocumentVillage,
  setDocumentFloor,
  setDocumentRoad,
  setDocumentProvince,
  setDocumentDistrict,
  setDocumentSubDistrict,
  setDocumentZipcode
}
